import { FLASH } from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = {
    message: '',
    open: false,
    type: 'success'
};

function reducer(state = initialState, action) {
    switch (action.type) {
        case FLASH.OPEN:
            return { ...state, message: action.message, open: true, type: action.flashType };
        case FLASH.CLOSE:
            return { ...state, open: false };
        case LOCATION_CHANGE:
            return initialState;
        default:
            return state;
    }
}

export default reducer;
